import { LOCALES } from 'utils/locale'

export const DATA_TESTID = 'exit-lesson-button'
export const EXIT_LESSON_TEXT = {
  [LOCALES.EN_US]: 'EXIT LESSON',
  [LOCALES.ES_US]: 'FIN DE LA LECCIÓN',
}
